<mat-card class="example-card">
    <mat-card-header class="titreFrm ">
      <mat-card-title>LISTE {{title.toUpperCase()}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <div class="display-flex">
          <mat-radio-group *ngIf="type=='1'" (change)="filterMachine()" name="Machine_Type" [(ngModel)]="machine_Type">
              <mat-radio-button [value]="'-1'">Tout</mat-radio-button>
              <mat-radio-button *ngFor="let type of listeMachine_Type" [value]="type.value">{{type.text}}</mat-radio-button>
          </mat-radio-group>
          <div *ngIf="showButtonChoisir">
            <button  [disabled]="!exist" (click)="choisir()" mat-raised-button class="colorBlue"><mat-icon>mouse</mat-icon>Choisir</button>
            <button  [disabled]="!exist" (click)="close()" mat-raised-button class="colorRed"><mat-icon>close</mat-icon>Fermer</button>
          </div>
          <div *ngIf="!showButtonChoisir">
            <button  [disabled]="!exist" (click)="goToMachine('3')" mat-raised-button class="colorGray"><mat-icon>import_contacts</mat-icon>Consulter</button>
            <button  [disabled]="!exist" (click)="goToMachine('2')" mat-raised-button class="colorBlue"><mat-icon>edite</mat-icon>Modifier</button>
            <button  [disabled]="!exist" (click)="supprimer()" mat-raised-button class="colorRed"><mat-icon>close</mat-icon>Supprimer</button>
            <button  [disabled]="!exist"  type="button" (click)="exportToExcel()" mat-raised-button class="colorGreen"><mat-icon>arrow_downward</mat-icon>Export Excel</button>
            
          </div>
        </div>
        
        <div *ngIf="showTab" style="margin-top : 10px">
          <app-avt-listes [multipleSelect]="false" #listeComponen [showFilter]="true" [heightTable]="'400'" [dataSourceBrut]="datasource" [displayedColumnsBrut]="column"  (btnTable)="clickBtnHeat($event)"></app-avt-listes>
        </div>
    </mat-card-content>
</mat-card>